import * as React from "react";
import {VeBoxModal} from "../../../../../components/modal/VeBoxModal";
import {AppTranslations} from "../../../../../components/Utils/translations/AppTranslations";
import "./styles.scss";
import {Button, capitalizeFirstLetter} from "@vebox/etui-core";
import {LoadingButton} from "../../../../../components/buttons/LoadingButton";

declare var AppTranslations: AppTranslations;

interface DeleteOrContinueModalProps {
    onDelete: () => void;
    onContinue?: () => void;
    isDeleting?: boolean;
    onXClick?: () => void;
    title?: string;
    deleteText?: string;
    continueText?: string;
    description?: JSX.Element;
}

export const DeleteOrContinueModal: React.FC<DeleteOrContinueModalProps> = ({
                                                                                onDelete,
                                                                                title,
                                                                                deleteText,
                                                                                continueText,
                                                                                isDeleting,
                                                                                onContinue,
                                                                                onXClick,
                                                                                description
                                                                            }) => {
    return (
        <VeBoxModal.Backdrop>
            <VeBoxModal>
                <VeBoxModal.Header
                    titleClassName={"modal-header-title"}
                    title={
                        <h2 className={"modal-header"}>
                            <span className="material-icons-outlined">info</span>
                            {title ? title : AppTranslations.genericWords.areYouSure}
                        </h2>
                    }
                    onClose={onXClick}
                />
                <VeBoxModal.Section>
                    <div className={"modal-body"}>
                        {description}
                    </div>
                </VeBoxModal.Section>
                <VeBoxModal.Actions>
                    <LoadingButton
                        variant={"tertiary"}
                        onClick={onDelete}
                        disabled={isDeleting}
                        loading={isDeleting}
                    >
                        {capitalizeFirstLetter(deleteText)}
                    </LoadingButton>
                    <Button
                        variant={"strong"}
                        onClick={onContinue}
                        disabled={isDeleting}
                    >
                        {capitalizeFirstLetter(continueText)}
                    </Button>
                </VeBoxModal.Actions>
            </VeBoxModal>
        </VeBoxModal.Backdrop>
    );
};
